import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import EmailCollection from "../components/emailCollection"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div style={{ textAlign: "center" }}>
      <h1 style={{ paddingBottom: "10%" }}>Coming Soon</h1>
      <EmailCollection />
    </div>

    {/* <Link to="/page-2/">Go to page 2</Link> <br /> */}
    {/* <Link to="/using-typescript/">Go to "Using TypeScript"</Link> */}
  </Layout>
)

export default IndexPage
